import { Grid, TextField, Button } from "@material-ui/core";

interface SearchBarProps {
    placeholder: string;
    searchTerm: string;
    onSearchTermChange: (value: string) => void;
    onSearch: () => void;
    onClearSearch: () => void;
}

/**
 * Search box + Search/Clear Search buttons shared by the Rheem Indicators,
 * Event Candidates, and Notes tables. Search only fires on Enter or a button
 * click, never on every keystroke - pair with `usePaginatedSearch`.
 */
export const SearchBar = ({ placeholder, searchTerm, onSearchTermChange, onSearch, onClearSearch }: SearchBarProps) => {
    return (
        <>
            <Grid item>
                <TextField
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={(e: any) => onSearchTermChange(e.target.value)}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            onSearch();
                        }
                    }}
                />
            </Grid>
            <Grid item>
                <Button variant="contained" onClick={onSearch}>Search</Button>
            </Grid>
            <Grid item>
                <Button variant="contained" onClick={onClearSearch}>Clear Search</Button>
            </Grid>
        </>
    );
};
